export function hasUserConsentLib() {
    return !!window.WM;
}

export function inUserConsentState(consentCategories) {
    return (window.WM) ? window.WM.UserConsent.inUserConsentState(consentCategories) : false;
}

export function isGDPR() {
    return (window.WM.UserConsent.getRegion() === 'gdpr');
}

export function isCCPA() {
    return (window.WM.UserConsent.getRegion() === 'ccpa');
}


// WEBPACK FOOTER //
// ./src/utils/UserConsent.js